module.exports = __webpack_public_path__ + "img/carte.6f3259ac.png";